/* Tek bir ince çizgi ikon seti. Hepsi 24×24, currentColor, 1.3 kalınlık. */

interface Props {
  className?: string;
}

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.3,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function IconClock({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.4V12l3 1.9" />
    </svg>
  );
}

export function IconHanger({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M12 11.4V10a2 2 0 1 1 2-2" />
      <path d="m12 11.4-7.6 4.9c-.8.5-.4 1.8.5 1.8h14.2c.9 0 1.3-1.3.5-1.8L12 11.4Z" />
    </svg>
  );
}

export function IconSpark({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M12 3.8c.6 4 3.6 7 7.6 7.6-4 .6-7 3.6-7.6 7.6-.6-4-3.6-7-7.6-7.6 4-.6 7-3.6 7.6-7.6Z" />
    </svg>
  );
}

export function IconMoon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M19.2 14.8A7.6 7.6 0 0 1 9.2 4.8a7.6 7.6 0 1 0 10 10Z" />
    </svg>
  );
}

export function IconMic({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <rect x="9" y="3.2" width="6" height="10.2" rx="3" />
      <path d="M5.6 11.6a6.4 6.4 0 0 0 12.8 0" />
      <path d="M12 18v2.6" />
    </svg>
  );
}

export function IconChevron({ className, open }: Props & { open?: boolean }) {
  return (
    <svg {...base} className={className} data-open={open ? "true" : "false"} width="18" height="18">
      <path d="m6 9.5 6 5.5 6-5.5" />
    </svg>
  );
}
